import { render } from "./NewsRssFeed.vue?vue&type=template&id=39b2a9aa"
import script from "./NewsRssFeed.vue?vue&type=script&lang=js"
export * from "./NewsRssFeed.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__